'use client';

import { CustomerlyProvider } from 'react-live-chat-customerly';
import CustomerlyLoader from '@/components/utils/customerly/CustomerlyLoader';

interface CustomerlyWrapperProps {
  children: React.ReactNode;
}

const CustomerlyWrapper = ({ children }: CustomerlyWrapperProps) => {
  const init = process.env.NEXT_PUBLIC_CUSTOMERLY_INIT !== '0';

  if (!init) return <>{children}</>;

  return (
    <CustomerlyProvider appId={process.env.NEXT_PUBLIC_CUSTOMERLY_PROJECT_ID || ''}>
      <CustomerlyLoader />
      {children}
    </CustomerlyProvider>
  );
};

export default CustomerlyWrapper;
